module.exports = __webpack_public_path__ + "img/crowd.f548f548.jpg";